import {useNavigate} from 'react-router-dom';
import {useState, useEffect} from 'react';
import sampleProperties from '../sample-properties';
import {getSavedAnalyses} from '../savedAnalysesStorage';

function Landing() {
    const navigate = useNavigate();
    const midrandPropertyLink = sampleProperties.find((p) => p.id === 'midrand').link;
    const capeTownPropertyLink = sampleProperties.find((p) => p.id === 'capeTown').link;
    const [savedCount, setSavedCount] = useState(0);

    useEffect(() => {
        setSavedCount(getSavedAnalyses().length);
    }, []);

    function navigateTo(link) {
        console.log(link);
        navigate(link);
    }

    return (
        <div className={'landing-container'}>
            <div className={'mt-50'}>
                <h3 className={'text-center mb-2'}>What would you like to do? </h3>
            </div>
            {savedCount > 0 && (
                <div className="property-card mb-10 pointer" onClick={() => navigateTo('/saved')}>
                    <div className="card-content" style={{background: '#2a4a6b'}}>
                        <div className="text-container">
                            <div className="card-title" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8}}>
                                Saved Analyses
                                <span style={{
                                    backgroundColor: '#FFD700',
                                    color: '#1A2B3C',
                                    fontSize: 11,
                                    fontWeight: 600,
                                    borderRadius: '50%',
                                    width: 22,
                                    height: 22,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>{savedCount}</span>
                            </div>
                            <div className="card-description" style={{fontSize: 14}}>View your previously saved analyses</div>
                        </div>
                    </div>
                </div>
            )}
            <div className="property-card mb-10 pointer" onClick={() => navigateTo(midrandPropertyLink)}>
                <div className="card-content">
                    <div className="image-container">
                        {/*<img src="https://images.prop24.com/327172783/Crop600x400" alt="Property in Midrand" />*/}
                        <img src="/midrand-prop.jpeg" alt="Property in Midrand" />
                    </div>
                    <div className="text-container">
                        <div className="card-description">Analyse example</div>
                        <div className="card-title">1 Bed Apartment in Midrand</div>
                    </div>
                </div>
            </div>
            <div className="property-card mb-10 pointer" onClick={() => navigateTo(capeTownPropertyLink)}>
                <div className="card-content">
                    <div className="image-container">
                        <img
                            // src="https://img.jamesedition.com/listing_images/2023/06/29/12/56/57/0675e124-4c8f-4060-8ad0-8ba6b5556009/je/760xxsxm.jpg"
                            src="/ct-prop.jpg"
                            alt={'Property in Cape Town'}
                        />
                    </div>
                    <div className="text-container">
                        <div className="card-description">Analyse example</div>
                        <div className="card-title">1 Bed Apartment in Cape Town</div>
                    </div>
                </div>
            </div>
            <div className="property-card mb-10 pointer " onClick={() => navigateTo('/')}>
                <div className="card-content gold-bg text-dark-blue">
                    <div className="image-container">
                        <img src="/mansion2.jpg" alt={'Property in Cape Town'} />
                    </div>
                    <div className="text-container">
                        <div>
                            <img src="/crown.svg" width={35} alt={''} />
                        </div>
                        <div className="card-title">Analyse your own rental property</div>
                        {/*<div className="card-description">1 bedroom apartment in Cape Town</div>*/}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Landing;
